import { Button } from 'antd';
import { config } from 'config/config';
import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { AnyAction, Dispatch, bindActionCreators } from 'redux';
import {
  setShowDiscoveryModal,
  setShowSpecialDiscoveryCoupon,
  setUserCampaigns,
} from 'src/actions/appActions';
import { IRootReducers } from 'src/reducers';
import { ICampaign, IDiscoveryCoupon } from 'src/shared/models';
import getConfig from 'next/config';
import Router from 'next/router';
import { getDiffInMiliseconds, getTimeFormat } from './discoveryGetTimeFunctions';
import { DiscoveryCampaignsConfig } from 'config/discovery-campaigns';


const { publicRuntimeConfig } = getConfig();

export interface discoveryDesktopBannerData {
  campaign: ICampaign;
  discoveryCoupons: IDiscoveryCoupon[];
  setDiscoveryCoupons;
}

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  discoveryDesktopBannerData;

const DiscoveryDesktopBanner: FC<Props> = ({
  campaign,
  setShowDiscoveryModal,
  setUserCampaigns,
}): JSX.Element => {
  const prefixImage = publicRuntimeConfig?.DEFAULT_LANGUAGE?.toUpperCase()?.replace('-', '_');
  const srcDiscoveryBanner = `${config.APP.MEDIA_CON}${prefixImage}_Discovery_Banner_Desktop.png`;

  const [disabledButton, setDisabledButton] = useState(false);
  const [clickDiscoveryButton, setClickDiscoveryButton] = useState(true);

  const { formatMessage } = useIntl();
  const [time, setTime] = useState(getDiffInMiliseconds(campaign));
  const [timeFormat, setTimeFormat] = useState(getTimeFormat(time));

  const isCampaignDiscoverySpecial = campaign && campaign?.type && !!DiscoveryCampaignsConfig?.[campaign.type];
  let campaignSpecial;
  if (isCampaignDiscoverySpecial) { campaignSpecial =  DiscoveryCampaignsConfig?.[campaign?.type] }

  const discoveryBannerImg = (): string => {
    return !isCampaignDiscoverySpecial ? srcDiscoveryBanner : campaignSpecial?.images?.banner?.home?.desktop;
  }

  const discoveryBannerTextStylesCampaign = (): {color: string} => {
    return isCampaignDiscoverySpecial ? { color: campaignSpecial?.styles?.banner?.home?.title } : undefined;
  }

  const discoveryBannerClockDigitStylesCampaign = ():{color: string} => {
    return isCampaignDiscoverySpecial ? {color: campaignSpecial?.styles?.banner?.home?.clock} : undefined;
  }

  const discoveryBannerClockDateStylesCampaign = ():{color: string} => {
    return isCampaignDiscoverySpecial ? {color: campaignSpecial?.styles?.banner?.home?.date} : undefined;
  }
  
  const discoveryBannerBackgroundStylesCampaign = ():{background: string} => {
    return isCampaignDiscoverySpecial ? {background: campaignSpecial?.styles?.banner?.home?.background} : undefined;
  }

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(time - 1000);
    }, 1000);
    return () => clearInterval(intervalId);
  });

  useEffect(() => {
    if (time < 0) {
      setUserCampaigns();
      setDisabledButton(true);
      setShowSpecialDiscoveryCoupon(false);
    } else {
      setTimeFormat(getTimeFormat(time));
    }
  }, [time]);

  useEffect(() => {
    if (time < 0) {
      setDisabledButton(true);
      setShowSpecialDiscoveryCoupon(false);
    }
  }, []);

  const convertToTwoDigit = (digit: number) => {
    return digit.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
    });
  };

  const discoverCoupon = async () => {
    if (clickDiscoveryButton) {
      const url = new URL(window.location.href);
      url.searchParams.append('campaign', campaign.id);
      history.pushState(null, null, url.toString());
      setShowDiscoveryModal(true);
    } else {
      Router.push({
        pathname: publicRuntimeConfig.PLATFORM_PREFIX,
      });
    }
    setClickDiscoveryButton(!clickDiscoveryButton);
  };

  return (
    <div className="discovery-desktop-banner" style={discoveryBannerBackgroundStylesCampaign()}>
      <div className="discovery-desktop-banner-img-container">
        <img
          className="discovery-desktop-banner-img"
          src={discoveryBannerImg()}
        />
        <div className="discovey-banner-content">
          <p className="specialCouponTextContainer banner-margin-left" style={discoveryBannerTextStylesCampaign()}>
            {formatMessage({
              id: 'consumable.coupon.special.text',
            })}
          </p>
          <div className="discovery-desktop-banner-clock-button">
            <div className="specialCouponClock ">
              <div className="clockDigitContainer">
                <span className="clockDigit" style={discoveryBannerClockDigitStylesCampaign()}>
                  {convertToTwoDigit(timeFormat.days)}
                </span>
                <p className="clockDigitText" style={discoveryBannerClockDateStylesCampaign()}>
                  {formatMessage({
                    id: 'consumable.coupon.special.clock.days',
                  })}
                </p>
              </div>
              <div className="clockDigitContainer">
                <span className="clockDigit" style={discoveryBannerClockDigitStylesCampaign()}>
                  {convertToTwoDigit(timeFormat.hours)}
                </span>
                <p className="clockDigitText" style={discoveryBannerClockDateStylesCampaign()}>
                  {formatMessage({
                    id: 'consumable.coupon.special.clock.hours',
                  })}
                </p>
              </div>
              <div className="clockDigitContainer">
                <span className="clockDigit" style={discoveryBannerClockDigitStylesCampaign()}>

                  {convertToTwoDigit(timeFormat.minutes)}
                </span>
                <p className="clockDigitText" style={discoveryBannerClockDateStylesCampaign()}>
                  {formatMessage({
                    id: 'consumable.coupon.special.clock.minutes',
                  })}
                </p>
              </div>
              <div className="clockDigitContainer">
                <span className="clockDigit" style={discoveryBannerClockDigitStylesCampaign()}>
                  {convertToTwoDigit(timeFormat.seconds)}
                </span>
                <p className="clockDigitText" style={discoveryBannerClockDateStylesCampaign()}>
                  {formatMessage({
                    id: 'consumable.coupon.special.clock.seconds',
                  })}
                </p>
              </div>
            </div>
            <div className="button-banner-desktop-discovery">
              <Button
                className="btn-primary btn-primary--black qr-landing__login__form__button__logged specialDiscoveryButton"
                onClick={discoverCoupon}
                disabled={disabledButton}>
                {formatMessage({
                  id: 'consumable.coupon.discovery.button',
                })}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: IRootReducers) => {
  return {
    userCampaigns: state.app.userCampaigns,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators(
    { setShowDiscoveryModal, setShowSpecialDiscoveryCoupon, setUserCampaigns },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DiscoveryDesktopBanner);
